export const automatedVoiceDocumentationMarkdown = `
### What does this block do?
The Automated Voice Block places a one-way phone call and reads a text-to-speech message to the recipient. The recipient cannot respond. The block waits for the call to end and outputs how it ended.

### When to use it?
- Use this block for reminders and notifications that the recipient only needs to hear.
- Use a Conversational Voice block instead when the recipient needs to talk to an assistant or take an action.

### How to configure this block
1. **Recipient Phone Number:** A US or Canadian phone number in E.164 format (e.g. "+14155551234"). You can insert variables from upstream blocks.
2. **Caller Phone Number:** The phone number the call is placed from. It must be a number your organization owns; manage numbers on the Phone Numbers page.
3. **Message:** The text read aloud once the call is answered. If voicemail answers, the same message plays after the beep. You can insert variables from upstream blocks. The resolved message can be up to 3,000 characters.
4. **End Call on Voicemail:** Turn this on when the message contains PHI. The call stays silent until a person is detected, then plays the message. If voicemail answers, or the call can't tell who answered, it hangs up without playing anything.
5. **Language, Voice, and Speed:** Choose English or Spanish, a voice for that language, and a speaking speed from 0.5 to 2 (1 is normal speed). Changing the language resets the voice to the default for that language.
6. **Timeout:** How long to wait for the call to end. If the call has not ended by then, the block finishes with \`timedOut\` set to \`true\`.
7. **Valid Windows:** The days and hours during which calls can be placed. Outside that window, the block fails without placing the call.

### Output
- **callSid**: The Twilio call identifier.
- **status**: The final Twilio call status, such as \`completed\`, \`busy\`, \`no-answer\`, or \`failed\`.
- **answeredBy**: Who answered: \`Human\`, \`Machine\`, \`Fax\`, or \`Unknown\`.
- **durationSeconds**: How long the call lasted.
- **errorCode**: The Twilio error code, if the call failed.
- **timedOut**: Whether the timeout passed before the call ended.

### Example Output

~~~json
{
    "callSid": "CA00000000000000000000000000000000",
    "status": "completed",
    "answeredBy": "Human",
    "durationSeconds": 18,
    "timedOut": false
}
~~~
`;
